import {Routes} from '@angular/router';
import {LoginComponent} from '@app/modules/layout/login/login.component';
import {AuthGuard} from '@app/shared';
import {LayoutModule} from '@app/modules/layout/layout.module';
import {AccessDeniedComponent} from '@app/components/access-denied/access-denied.component';
import {NotFoundComponent} from '@app/components/not-found/not-found.component';

export const routes: Routes = [
  {path: '', loadChildren: () => LayoutModule, canActivate: [AuthGuard], data: {level: 0, path: "/layout"}},
  {path: 'login', loadComponent: () => LoginComponent},
  {path: 'access-denied', loadComponent: () => AccessDeniedComponent},
  {path: 'not-found', loadComponent: () => NotFoundComponent},
  {path: '**', redirectTo: 'not-found'}
];
